import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

export type IntegrationProviderOption = {
    id: number;
    name: string;
};

type IntegrationProviderSelectProps = {
    providerId: number;
    providerOptions: IntegrationProviderOption[];
    onChange: (providerId: number) => void;
};

export default function IntegrationProviderSelect({
    providerId,
    providerOptions,
    onChange
}: IntegrationProviderSelectProps) {
    const handleChange = (event: SelectChangeEvent<number>) => {
        onChange(Number(event.target.value));
    };

    return (
        <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel id="integration-provider-label">Provider</InputLabel>
            <Select
                data-testid="integration-provider-select"
                labelId="integration-provider-label"
                value={providerId}
                label="Provider"
                onChange={handleChange}
            >
                {providerOptions.map((provider) => (
                    <MenuItem key={provider.id} value={provider.id}>
                        {provider.name}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>Select the external system to connect.</FormHelperText>
        </FormControl>
    );
}
